'use client'

import { UserSessionBootstrap } from '@core/auth'
import { PropsWithChildren, Suspense } from 'react'

export default function PrivateLayout({ children }: PropsWithChildren) {
  return (
    <Suspense>
      <UserSessionBootstrap>{children}</UserSessionBootstrap>
    </Suspense>
  )
}
